webpackJsonp([0],{

/***/ "2BZN":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"app"}},[_c('hello')],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "47Rh":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"container"},[(!_vm.finished)?_c('div',[_c('h2',[_vm._v(_vm._s(_vm.question))]),_vm._v(" "),_vm._l((_vm.options),function(q){return _c('div',[_c('button',{staticClass:"btn btn-primary btn-lg btn-block",attrs:{"type":"button"},on:{"click":function($event){_vm.updateQuestion(q)}}},[_vm._v(_vm._s(q.option))]),_vm._v(" "),_c('br')])})],2):_c('div',[_c('h1',[_vm._v(_vm._s(_vm.result.result))]),_vm._v(" "),(_vm.result.positive)?_c('div',[_c('img',{staticClass:"img-fluid",attrs:{"src":"static/love.jpg"}})]):_c('div',[_c('img',{staticClass:"img-fluid",attrs:{"src":"static/vuil.jpg"}})]),_vm._v(" "),_c('button',{staticClass:"btn btn-primary btn-lg btn-block",attrs:{"type":"button"},on:{"click":_vm.reset}},[_vm._v("Opnieuw?")])])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "BvSD":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "M93x":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_App_vue__ = __webpack_require__("xJD8");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_226a5be2_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_node_modules_vue_loader_lib_selector_type_template_index_0_App_vue__ = __webpack_require__("2BZN");
function injectStyle (ssrContext) {
  __webpack_require__("SicG")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_App_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_226a5be2_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_node_modules_vue_loader_lib_selector_type_template_index_0_App_vue__["a" /* default */],
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "NHnr":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__("7+uW");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__App__ = __webpack_require__("M93x");
// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.



__WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].config.productionTip = false;

/* eslint-disable no-new */
new __WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */]({
  el: '#app',
  template: '<App/>',
  components: { App: __WEBPACK_IMPORTED_MODULE_1__App__["a" /* default */] }
});

/***/ }),

/***/ "SicG":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "pMZz":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'hello',
  data: function data() {
    return {
      questions: {
        "question": "Is de kaas Nederlands?",
        "options": [{
          "option": "Ja",
          "finished": false,
          "next_question": {
            "question": "Komt de kaas uit de koelkast?",
            "options": [{
              "option": "Ja",
              "finished": false,
              "next_question": {
                "question": "Is de kaas jong of oud?",
                "options": [{
                  "option": "(Jong) belegen",
                  "finished": false,
                  "next_question": {
                    "question": "Is de kaas 48+?",
                    "options": [{
                      "option": "Ja",
                      "finished": true,
                      "positive": true,
                      "result": "Ik lust het"
                    }, {
                      "option": "Nee",
                      "finished": true,
                      "positive": false,
                      "result": "Waarschijnlijk vind ik het smerig"
                    }]
                  }
                }, {
                  "option": "Oud",
                  "finished": true,
                  "positive": false,
                  "result": "Waarschijnlijk vind ik het smerig"
                }]
              }
            }, {
              "option": "Nee",
              "finished": false,
              "next_question": {
                "question": "Zit het op *niet door* pizza, tosti of pasta?",
                "options": [{
                  "option": "Ja",
                  "finished": true,
                  "positive": true,
                  "result": "Ja, ik lust het"
                }, {
                  "option": "Nee",
                  "finished": true,
                  "positive": false,
                  "result": "Nee, goor"
                }]
              }
            }]
          }
        }, {
          "option": "Nee",
          "finished": false,
          "next_question": {
            "question": "Waarschijnlijk lust ik het niet maar oke. Is het mozarella of parmezaans?",
            "options": [{
              "option": "Ja",
              "finished": true,
              "positive": true,
              "result": "Ja ik lust het"
            }, {
              "option": "Nee",
              "finished": true,
              "positive": false,
              "photo": "./../assets/vuil.jpeg",
              "result": "Stop maar, tis vuil!"
            }]
          }
        }]
      },
      question: "",
      finished: false,
      options: [],
      result: {}
    };
  },


  methods: {
    updateQuestion: function updateQuestion(option) {
      if (option.finished) {
        this.finished = true;
        this.result = option;
      } else {
        this.question = option.next_question.question;
        this.options = option.next_question.options;
      }
    },
    reset: function reset() {
      this.finished = false;
      this.question = this.questions.question;
      this.options = this.questions.options;
    }
  },

  mounted: function mounted() {
    this.reset();
  }
});

/***/ }),

/***/ "qSdX":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Hello_vue__ = __webpack_require__("pMZz");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_5c7ef05b_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_node_modules_vue_loader_lib_selector_type_template_index_0_Hello_vue__ = __webpack_require__("47Rh");
function injectStyle (ssrContext) {
  __webpack_require__("BvSD")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-5c7ef05b"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Hello_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_5c7ef05b_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_node_modules_vue_loader_lib_selector_type_template_index_0_Hello_vue__["a" /* default */],
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "xJD8":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_Hello__ = __webpack_require__("qSdX");
//
//
//
//
//
//



/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'app',
  components: {
    Hello: __WEBPACK_IMPORTED_MODULE_0__components_Hello__["a" /* default */]
  }
});

/***/ })

},["NHnr"]);


// WEBPACK FOOTER //
// static/js/app.01058130e5181c4856a7.js